var map = {
	"./Hyphen.png": 99402,
	"./Hyu.png": 48879,
	"./Lifespan.png": 55831,
	"./Renee.png": 34690,
	"./Snitch.png": 8063,
	"./Swiss Beauty.png": 62848,
	"./WeRize.png": 34865,
	"./adidas.png": 14465,
	"./amazon.png": 8664,
	"./beato.png": 17208,
	"./bella-vita.png": 20010,
	"./boat.png": 74189,
	"./boldcare.png": 46289,
	"./bombay-shaving-company.png": 36115,
	"./booking-com.png": 14158,
	"./cadbury.png": 77078,
	"./clove-oral-care.png": 7840,
	"./croma.png": 5809,
	"./dot-and-key.png": 31647,
	"./fab-india.png": 37796,
	"./firstcry.png": 25002,
	"./fitspire.png": 95488,
	"./flipkart.png": 5424,
	"./forest-essentials-india.png": 26795,
	"./foxtale.png": 28173,
	"./giva.png": 38835,
	"./go-noise.png": 86493,
	"./kama.png": 94661,
	"./koparo-clean.png": 34753,
	"./libas.png": 74147,
	"./mamaearth.png": 96707,
	"./mcaffeine.png": 18736,
	"./medibuddy.png": 49649,
	"./minimalist.png": 33922,
	"./muscleblaze.png": 83689,
	"./neeman.png": 46581,
	"./nykaa.png": 84272,
	"./plum-goodness.png": 73749,
	"./puer.png": 42239,
	"./puma.png": 65448,
	"./shopsy.png": 61415,
	"./shyaway.png": 5604,
	"./smytten.png": 38531,
	"./sova-health.png": 71054,
	"./ssbeauty.png": 7283,
	"./the-derma-co.png": 46121,
	"./the-man-company.png": 32495,
	"./times-prime.png": 34910,
	"./truemeds.png": 40360,
	"./weryze.png": 30927,
	"./world-of-asaya.png": 24657,
	"./wow.png": 64242,
	"./xyxx-crew.png": 39898,
	"./zandu-care.png": 43259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6281;